import Swal from 'sweetalert2'
import {AUTH_LOCAL_STORAGE_KEY} from './AuthHelpers'

// Shared "session is no longer valid" handler used both by the reload-time
// expiry check (Auth.tsx) and the global 401 interceptor (services/api.ts).
// Lives in its own module so api.ts can import it without creating a cycle
// (api → session → Swal only; no path back into api).

let handling = false // guards against stacked alerts when several calls 401 at once

const clearSession = () => {
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_user')
}

// Shows a countdown alert, then clears the session and sends the user to login.
// A full reload is the simplest way to reset all in-memory auth state.
export const handleSessionExpired = () => {
  if (handling) return
  handling = true

  const seconds = 5
  Swal.fire({
    icon: 'warning',
    title: 'Session expired',
    html: `For your security you've been signed out. Redirecting to login in <b>${seconds}</b>s…`,
    timer: seconds * 1000,
    timerProgressBar: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      const b = Swal.getPopup()?.querySelector('b')
      let remaining = seconds
      const iv = setInterval(() => {
        remaining -= 1
        if (b) b.textContent = String(Math.max(remaining, 0))
      }, 1000)
      ;(Swal.getPopup() as any).__countdown = iv
    },
    willClose: () => {
      clearInterval((Swal.getPopup() as any)?.__countdown)
    },
  }).then(() => {
    clearSession()
    window.location.href = '/auth/login'
  })
}
